// ======= plugin import ======== //
import {useState, useEffect, useRef} from 'react'
import Swal from 'sweetalert2';
import axios from 'axios'
// ======== component import =========== //
import SideDrawer from '../../../../../../../../component/common/SideDrawer';
import AddFinalSetup from './component/AddFinalSetup';
import FinalSetupUpdateDrawer from './component/FinalSetupUpdateDrawer';
import FinalSetupList from './component/FinalSetupList';

const FinalSetup = (props) => {
    const {formData, formValidateError} = props;

    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;

    // ------ define all here ------ //
    const [ finalFormSetupChange, setFinalFormSetupChange ] = useState(false);
    const [ othersFormUpdateId , setOthersFormUpdateId] = useState(-1)
    const [ othersFormList , setOthersFormList] = useState([]);
    const [ finalSetupUpdateDrawerIsOpen, setFinalSetupUpdateDrawerIsOpen] = useState(false)
    const [ othersFormUpdateState , setOthersFormUpdateState] = useState([])
    const [isButtonLoader, setIsButtonLoader] = useState(false);
    const [isupdateInfoOpen, setIsupdateInfoOpen] = useState('')

    const othersFormSaveHandler = async (othersFormData) => {
        setFinalFormSetupChange(true)
        
        let isDuplicate = false;

        if(formData['step5'].final_form_setup.add_example !== ''){
            isDuplicate = formData['step5'].final_form_setup.some(
                (example) => example.add_example.trim() === othersFormData.add_example.trim()
            );
        }
        if(othersFormUpdateId < 0){
            // ---- insert ---- //
            if (isDuplicate) {
                await Swal.fire({
                    text: 'Duplicate example cannot be added !',
                    icon: 'error',
                    showCancelButton: true,
                    showConfirmButton : false,
                    cancelButtonText: 'OK',
                });
                return;
            }
            setIsButtonLoader(true)
            if(othersFormData.multiple_response){
                othersFormData.multiple_response = JSON.parse(othersFormData.multiple_response);
            }
            else{
                othersFormData.multiple_response = [];
            }
            setOthersFormList((prevList) => [...prevList, othersFormData]);
            props.onInputChange(
                'step5',
                'final_form_setup',
                [
                    ...(Array.isArray(formData['step5'].final_form_setup) ? formData['step5'].final_form_setup : []),
                    othersFormData
                ]
            );
        }
        else{
            // ---- update ------ //
            const othersFormSetupState = [...formData['step5'].final_form_setup];
            if(othersFormSetupState[othersFormUpdateId].add_example !== othersFormData.add_example){
                if (isDuplicate) {
                    await Swal.fire({
                        text: 'Duplicate example cannot be added !',
                        icon: 'error',
                        showCancelButton: true,
                        showConfirmButton : false,
                        cancelButtonText: 'OK',
                    });
                    return;
                }
            }
            setIsButtonLoader(true)
            if(othersFormData.multiple_response){
                othersFormData.multiple_response = JSON.parse(othersFormData.multiple_response);
            }
            else{
                othersFormData.multiple_response = [];
            }
            if(othersFormData.follow_up_details){
                if(othersFormData.follow_up_details.value === 'opt_in'){
                    othersFormData.closing_utterance = '';
                    othersFormData.feedback = '';
                }
                else if(othersFormData.follow_up_details.value === 'closing_utterance'){
                    othersFormData.affirm_of_deny = null;
                    othersFormData.feedback = '';
                    othersFormData.select_action = null;
                }
                else if(othersFormData.follow_up_details.value === 'feedback'){
                    othersFormData.affirm_of_deny = null;
                    othersFormData.closing_utterance = '';
                    othersFormData.select_action = null;
                }
            }
            if(othersFormData.affirm_of_deny){
                if(othersFormData.affirm_of_deny.value === 'no'){
                    othersFormData.select_action = null;
                }
            }
            othersFormSetupState[othersFormUpdateId] = othersFormData;
            setOthersFormList(othersFormSetupState);
            props.onInputChange(
                'step5',
                'final_form_setup',
                othersFormSetupState
            );
            setFinalSetupUpdateDrawerIsOpen(false)
        }
        setOthersFormUpdateId(-1)
    }
    const othersSetupUpdateOnClickHandler = (index) => {
        setOthersFormUpdateState([othersFormList[index]])
        setOthersFormUpdateId(index)
        setFinalSetupUpdateDrawerIsOpen(true)
    }
    const othersSetupDeleteOnClickHandler = (index) => {
        const updateOthersData = [...othersFormList];
        updateOthersData.splice(index, 1);
        setOthersFormList(updateOthersData);
        props.onInputChange(
            'step5',
            'final_form_setup',
            updateOthersData
        );
        setFinalFormSetupChange(true)
    }
    const finalSetupOnDropHandler = (rearrangeFinaleData) => {
        setFinalFormSetupChange(true)
        setOthersFormList(rearrangeFinaleData);
        props.onInputChange(
            'step5',
            'final_form_setup',
            rearrangeFinaleData
        );
    }
    const drawerOnCloseHandler = (drawerName) => {
        const drawerMap = {
            final_setup_update_drawer: () => {
                setFinalSetupUpdateDrawerIsOpen(false);
                setOthersFormUpdateId(-1);
            },
        };
        if (drawerMap[drawerName]) {
            drawerMap[drawerName]();
        }
    }
    useEffect(() => {
        setFinalFormSetupChange(false)
        setOthersFormList(formData['step5'].final_form_setup);
    },[formData['step5']]);

    const finalSetupFormRef = useRef(); 
    useEffect(() => {
        const finalFormDetails = async () => {
            if(!finalFormSetupChange) return;

            const saveFinalData = async () => {
                let finalData = [];
                if (othersFormList.length > 0) {
                    const indexFinalData = othersFormList.map((finalDataPrevData, index) => ({
                        ...finalDataPrevData,
                        index,
                    }));
                    finalData = indexFinalData
                }

                let apiToken = '';
                if(loginUserType === 'A'){
                    apiToken = localStorage.getItem('token')
                }
                else if(loginUserType === 'D'){
                    apiToken = localStorage.getItem('developertoken')
                }
                else if(loginUserType === 'SA') {
                    apiToken = localStorage.getItem('systemAdminToken')
                }

                let finalFormData = new FormData();
                finalFormData.append("action_type", 'final_form_setup');
                finalFormData.append("bot_id", formData.bot_id);
                finalFormData.append("step", "step5");
                finalFormData.append("data", JSON.stringify(finalData));
                finalFormData.append("sass_id", localStorage.getItem('sass_id'));
                finalFormData.append("user_type", localStorage.getItem('type'));
                finalFormData.append("user_name", loginUserType == 'SA' ? localStorage.getItem('system_username') : '');

                const apiHeaders = {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "x-access-token": apiToken,
                    },
                };
                try {
                    await axios.post(`${api_base_url}api/save-bot-details`, finalFormData, apiHeaders)
                    .then(async (res) => {
                        if(res.data.status === 'success'){
                            finalFormData = new FormData();
                            setFinalFormSetupChange(false)
                            finalSetupFormRef.current?.resetForm(); 
                            setIsButtonLoader(false)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                } catch (error) {
                    console.error("Error during save:", error);
                }
            }
            await saveFinalData();
        }
        finalFormDetails();
    },[othersFormList])

    return (
        <>
            <div className="row mb-5 p-5">
                <div className="col-md-12">
                    <AddFinalSetup
                        othersFormSave={othersFormSaveHandler}
                        othersFormUpdateState={othersFormUpdateState}
                        formValidateError={formValidateError}
                        formData={formData}
                        isInfoOpenHandler={props.isInfoOpenHandler}
                        ref={finalSetupFormRef}
                        isButtonLoader={isButtonLoader}
                    />
                </div>
                <div className='col-md-12'>
                    <FinalSetupList
                        othersFormList={othersFormList}
                        othersSetupUpdateOnClick={othersSetupUpdateOnClickHandler}
                        othersSetupDeleteOnClick={othersSetupDeleteOnClickHandler}
                        finalSetupOnDrop={finalSetupOnDropHandler}
                    />
                </div>
            </div>
            <SideDrawer
                title={'Data Update'}
                width={isupdateInfoOpen=== 'open' ? 900 : 600}
                open={finalSetupUpdateDrawerIsOpen}
                drawer_name={'final_setup_update_drawer'}
                placement={'right'}
                closable={false}
                drawerOnClose={drawerOnCloseHandler}
            >
                <FinalSetupUpdateDrawer
                    othersFormSave={othersFormSaveHandler}
                    othersFormUpdateState={othersFormUpdateState}
                    formValidateError={formValidateError}
                    formData={formData}
                    ref={finalSetupFormRef}
                    isButtonLoader={isButtonLoader}
                    isUpdateInfo= {(data) => setIsupdateInfoOpen(data.isOpen)}
                    drawerIsOpen={finalSetupUpdateDrawerIsOpen}
                />
            </SideDrawer>
        </>
    )
}

export default FinalSetup
